module.exports = __webpack_public_path__ + "static/pepsi_Page_3-6ae637d1da8139c7d1a111284c7ce020.jpg";